import PropTypes from 'prop-types';

import Button from 'core/components/Button';
import withTheme from 'core/hocs/withTheme';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';
import { Fragment } from 'react';

function ButtonWithIcon(props) {
  const {
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        button: buttonAtoms,
      },
    },
    children,
    icon: Icon,
    type,
    iconPosition,
    iconMargin,
    className,
    ...otherProps
  } = props;

  if (typeof Icon !== 'function') return <Button {...props} />;

  const buttonTypeAtoms = buttonAtoms[type] || buttonAtoms;
  const isLeft = iconPosition === 'left';
  const isRight = iconPosition === 'right';


  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .iconLeft
          margin-right ${iconMargin}px

        .iconRight
          margin-left ${iconMargin}px

        .buttonWithIcon
          & :global([id*="$"])
            fill ${buttonTypeAtoms.idle.color}
            transition fill ${hoverAnimation}

          &:hover :global([id*="$"])
            fill ${buttonTypeAtoms.hover.color}

          &:active :global([id*="$"])
            fill ${buttonTypeAtoms.active.color}

          &:disabled :global([id*="$"])
            fill ${buttonTypeAtoms.disabled.color}

          & :global([id*="!"])
            stroke ${buttonTypeAtoms.idle.color}
            transition stroke ${hoverAnimation}

          &:hover :global([id*="!"])
            stroke ${buttonTypeAtoms.hover.color}

          &:active :global([id*="!"])
            stroke ${buttonTypeAtoms.active.color}

          &:disabled :global([id*="!"])
            stroke ${buttonTypeAtoms.disabled.color}

          & :global([id*="@"])
            fill ${buttonTypeAtoms.idle.fill || buttonTypeAtoms.idle.color}
            transition fill ${hoverAnimation}

          &:hover :global([id*="@"])
            fill ${buttonTypeAtoms.hover.fill || buttonTypeAtoms.hover.color}

          &:active :global([id*="@"])
            fill ${buttonTypeAtoms.active.fill || buttonTypeAtoms.active.color}

          &:disabled :global([id*="@"])
            fill ${buttonTypeAtoms.disabled.fill || buttonTypeAtoms.disabled.color}
      `}</style>
    </scope>
  );

  const iconLeft = <Icon className={scope.wrapClassNames('iconLeft')} />;
  const iconRight = <Icon className={scope.wrapClassNames('iconRight')} />;
  return (
    <Fragment>
      <Button
        type={type}
        className={scope.wrapClassNames('buttonWithIcon', className)}
        {...otherProps}
      >
        {isLeft && iconLeft}
        {children}
        {isRight && iconRight}
      </Button>
      <scope.styles />
    </Fragment>
  );
}

ButtonWithIcon.propTypes = {
  /** @ignore */
  theme: themePropTypes(`{
    animations: {
      hover,
    },
  }`),

  /** Элемент, используемый в качестве иконки */
  icon: PropTypes.func,

  /** Определяет стиль отображения кнопки */
  type: PropTypes.string.isRequired,

  /** Позиция иконки */
  iconPosition: PropTypes.oneOf([
    'left',
    'right',
  ]),

  /** Отступ иконки от текста */
  iconMargin: PropTypes.number,
  className: PropTypes.string,
};

ButtonWithIcon.defaultProps = {
  type: 'primary',
  iconPosition: 'left',
  iconMargin: 10,
};

const ButtonWithIconHOCs = withTheme(ButtonWithIcon);
ButtonWithIconHOCs.displayName = 'ButtonWithIcon';

export { ButtonWithIcon as StorybookComponent };
export default ButtonWithIconHOCs;
